import { View } from "../BaseComponents/styles";
import BreadCrumb from "../BreadCrumb";
import { Line } from "../Line/styles";
import MacroContainer from "../MacroContainer";
import { Container } from "./styles";

export const OptionsSection = ({options}) => {
    return (
        <Container>
            <MacroContainer>
            <Line align={'space-between'} wrap="wrap">
                {options && options.start ||
                <Line>
                    <BreadCrumb/>
                </Line>
                }
                {options && options.middle ||
                    null
                }
                {options && options.end &&
                <Line align={'end'} wrap={'wrap'}>
                    {!Array.isArray(options.end) ? 
                    options.end
                    :
                    options.end.map(op=> {
                        return <View style={{margin: 5}}>
                            {op}
                        </View>;
                    })
                    }
                </Line>
                }
            </Line>
            </MacroContainer>
        </Container>
    );
}